module.exports = __webpack_public_path__ + "img/certContractSign.9f246ccc.png";